import React from 'react';

/**
 * Top-level error boundary — a component crash shows a friendly recovery
 * screen instead of a blank white page.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center',
          justifyContent: 'center', background: 'var(--color-background, #f4f1ec)',
          fontFamily: 'Georgia, serif', padding: '24px',
        }}>
          <div style={{
            background: '#fff', borderRadius: '16px', padding: '40px',
            maxWidth: '420px', textAlign: 'center',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          }}>
            <div style={{ fontSize: '40px', marginBottom: '12px' }}>🌿</div>
            <h2 style={{ margin: '0 0 12px', color: '#2c2c2c' }}>
              Something went wrong
            </h2>
            <p style={{ color: '#777', lineHeight: 1.6, marginBottom: '24px' }}>
              We hit an unexpected error. Your data is safe — let's take you
              back home.
            </p>
            <button
              onClick={this.handleReload}
              style={{
                background: '#1A6068', color: '#fff', border: 'none',
                padding: '12px 32px', borderRadius: '8px', fontSize: '16px',
                cursor: 'pointer', fontFamily: 'inherit',
              }}
            >
              Back to ELLai
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
